import { initZeGoEngine, getZeGoBasicToken } from "@/components/zego/zego-auth";
import { Notification, MessageBox, Message, Loading } from 'element-ui'

const roomID = 'Public';
let instance = '';

export function initZego(user,callback){
    // 初始化实例
    const zg = initZeGoEngine();
    zg.setDebugVerbose(false);

    //检测浏览器兼容情况
    zg.checkSystemRequirements("webRTC",0).then(result => {
        if(!result){
            alert("当前设备不支持webRTC协议");
        } else {
            handleEvent(callback);
            loginRoom(user);
        }
    });

    instance = zg;
    return zg;
}

export function handleEvent(callback){
    //流变化
    instance.on('roomStreamUpdate', async (roomID, updateType, streamList, extendedData) => {
        // 房间内其他用户音视频流变化的通知
        if (updateType === 'ADD') {
            // 流新增，开始拉流
            if(callback && callback.newStream){
                callback.newStream(streamList);
            }

        } else if (updateType === 'DELETE') {
            // 流删除，通过流删除列表 streamList 中每个流的 streamID 进行停止拉流。
            for (let i = 0; i < streamList.length; i++) {
                const streamID = streamList[i].streamID;
                instance.stopPlayingStream(streamID);
            }
            if(callback && callback.removeStream){
                callback.removeStream(streamList);
            }
        }
    });
    //接受命令
    instance.on('IMRecvCustomCommand', (roomID, fromUser, command) => {
        console.log("收到消息："+ command)
        switch (command) {
            case 'CallRequest' :
                MessageBox.confirm('收到新的来电是否接听', '来电提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '接听',
                    cancelButtonText: '拒绝',
                    type: 'warning',
                    center:true
                }).then(() => {
                    if(callback.requestAccess){
                        callback.requestAccess(fromUser);
                    }
                    // this.showVideo(fromUser);
                }).catch(action => {
                    if(action === 'cancel'){
                        instance.sendCustomCommand(roomID,"refuseCall",[fromUser.userID]);
                    }
                });
                break;
            case 'stopVideo' :
                MessageBox.alert("对方已挂断", "系统提示", { type: 'error' })
                if(callback.endCall){
                    callback.endCall(fromUser);
                }
                break;
            default:
                console.error("收到未知指令："+command);
        }
    });

}

export function loginRoom(user){
    const token = getZeGoBasicToken(user.userID);
    instance.loginRoom(roomID, token, { userID:user.userID, userName: user.userName }, { userUpdate: true }).then(async result => {
        if (result === true) {
            console.log("视频通话登录成功");
        }
    });
}

export function startPlayRemote(user){
    instance.sendCustomCommand(roomID,"pushVideo",[user.userID]);
}

export function stopPlayRemote(user){
    //停止拉去远端流
    instance.stopPlayingStream(user.userID + '_stream');
    instance.sendCustomCommand(roomID,"stopVideo",[user.userID]);
}

export async function startPlayRemoteStream(container,streamID){
    // streamList 中有对应流的 streamID
    const remoteStream = await instance.startPlayingStream(streamID);
    // 创建媒体流播放组件
    const remoteView = instance.createRemoteStreamView(remoteStream);
    remoteView.play(container, {enableAutoplayDialog:true});
}

export async function startPublishLocal(container,streamID){
    // 与房间连接成功，只有当房间状态是连接成功时，才能进行推流、拉流等操作。
    // 创建流、预览
    // 调用 createStream 接口后，需要等待 ZEGO 服务器返回流媒体对象才能执行后续操作
    const localStream = await instance.createStream();
    // 创建媒体流播放组件
    const localView =  instance.createLocalStreamView(localStream);
    localView.play(container, {enableAutoplayDialog:true});
    // 开始推流，将自己的音视频流推送到 ZEGO 音视频云，此处 streamID 由用户定义，需全局唯一
    instance.startPublishingStream(streamID, localStream);
    return localStream;
}

export function stopPublishLocal(streamID,localStream){
    //停止本地推流
    instance.stopPublishingStream(streamID);
    //销毁本地流
    if(localStream){
        instance.destroyStream(localStream);
        console.log("本地流已销毁")
    }

}